module.exports = __webpack_public_path__ + "media/images/flags/64/Suriname-21da138f6fdeab986112bf155451ddb4.png";